import { uniq } from 'lodash-es';

export default function (objectName) {
  return {
    socket_aluaRefreshed({ dispatch, commit }, event) {
      const object = event.object[objectName];
      object.deleted.map(id => commit('REMOVE', id));
      const ids = uniq([...object.updated, ...object.created]);
      return Promise.all(ids.map(id => dispatch('FETCH_ITEM', { id })));
    }
  };
}
